import { UseMutationResult, useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { IFreebieRule } from "../../sdk/types";
import { api } from "../../sdk/utils";
import { FreebieRuleStatus, FreebieRuleType } from "../../utils/enums";

export interface ICreateFreebieRuleParameters {
    name: string;
    type: FreebieRuleType;
    status: FreebieRuleStatus;
    priority: number;
    minCartValue: number | null;
    discountCode: string | null;
    quantity: number;
    startsAt: Date | null;
    endsAt: Date | null;
    triggerVariantIds: string[];
    freebieVariantIds: string[];
}

export const useCreateFreebieRule = (
    queryKey: string | string[],
): UseMutationResult<IFreebieRule, unknown, ICreateFreebieRuleParameters> => {
    const auth = useAuth();
    return useMutation<IFreebieRule, unknown, ICreateFreebieRuleParameters>({
        mutationFn: async (parameters: ICreateFreebieRuleParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot create freebie rule without authorization token.",
                );
            }

            return await api.freebieRule.createFreebieRule({
                ...parameters,
                token: auth.token,
            });
        },
    });
};
